import { GrowthStatistics } from "@app/statistics/statistics-growth/models/growth-statistics";
import * as widgetActions from "@app/widgets/widgets/statistics-budget-widget/ngrx/statistics-budget-widget.actions";
import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { WidgetsModuleState } from "@app/widgets/widgets-module.reducer";

export interface BudgetState {
  stats: GrowthStatistics;
  loading: boolean;
}

export const initialState: BudgetState = {
  loading: false,
  stats: null,
};

export function budgetReducer(state: BudgetState, action: Action): BudgetState {
  return reducer(state, action);
}

const reducer = createReducer(
  initialState,
  on(widgetActions.fetchStatisticsRequest, (state) => ({
    ...state,
    loading: true,
  })),
  on(widgetActions.fetchStatisticsSuccess, (state, { growth }) => ({
    ...state,
    loading: false,
    stats: growth,
  })),
  on(widgetActions.fetchStatisticsFail, (state) => ({
    ...state,
    loading: false,
  }))
);

const selectFeature = createFeatureSelector<WidgetsModuleState>("widgets");

const getState = createSelector(
  selectFeature,
  (state: WidgetsModuleState) => state.budget
);

export const getStats = createSelector(
  getState,
  (state: BudgetState) => state.stats
);

export const getLoading = createSelector(
  getState,
  (state: BudgetState) => state.loading
);
